import { render } from "./CollectionDetailedSearchNewspapers.vue?vue&type=template&id=648b1b6a&scoped=true&ts=true"
import script from "./CollectionDetailedSearchNewspapers.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchNewspapers.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchNewspapers.vue?vue&type=style&index=0&id=648b1b6a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648b1b6a"]])

export default __exports__